// extracted by mini-css-extract-plugin
module.exports = {"logo":"ModalLogin_logo__1SXP8","btns":"ModalLogin_btns__rN3vf"};